module.exports = __webpack_public_path__ + "img/banner_smzlpg.507af32b.png";